import { IProduct } from "@faire/web-api--source/indigofair/data/IProduct";
export var getVariantDescriptorSuffixDropdown = function(variationState, strictLocalize) {
    if (variationState === undefined) {
        return strictLocalize({
            id: "GTnbnJ",
            defaultMessage: [
                {
                    type: 0,
                    value: "(Unavailable)"
                }
            ]
        });
    }
    if (variationState === IProduct.State.SALES_PAUSED) {
        return strictLocalize({
            id: "46lox2",
            defaultMessage: [
                {
                    type: 0,
                    value: "(Out of stock)"
                }
            ]
        });
    }
    return;
};
export var getVariantDescriptorSuffix = function(variationState, strictLocalize) {
    if (variationState === undefined) {
        return strictLocalize({
            id: "m50S3u",
            defaultMessage: [
                {
                    type: 0,
                    value: "Unavailable"
                }
            ]
        });
    }
    if (variationState === IProduct.State.SALES_PAUSED) {
        return strictLocalize({
            id: "M8YeRB",
            defaultMessage: [
                {
                    type: 0,
                    value: "Out of stock"
                }
            ]
        });
    }
    return;
};
